/*
 * Copyright (C) iSchoolConnect - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
// the values for these enum should be the same as the value for the key 'identifier'
// from the '/public' api response which get's called when chatbot initializes for the first time
export enum CHATBOT_VARIANTS {
	NYU = 'nyu',
	ISC = 'isc',
}
